
export const CURRENT_CONFIG = {

  // license

  appId: '167127',

  appKey: 'ce7fd418b1dcf048c2c8b1b398148b4',

  appLicense: 'VFSt0NuOYh7mXvqZ/6phYWTUWMo6A0W8yrRcfunzwNU/cLB6M1iWVCGi5AGnJ/Ogl+ge8OpQfHqwqV/XrweIJQ6qhPic9Oig62PVp4582YwimPmuHs6yEwCJ4qZjZnU7JZEH7fpsfOFusmqZ+byott2Ce51fM7stmHB4+So3Qms=',

  // http

  baseURL: 'https://dji.thulda.de/',

  websocketURL: 'wss://dji.thulda.de/api/v1/ws',

  // livestreaming

  rtmpURL: 'rtmp://s1.skyresq.de:1935/live/',

  gbServerIp: '',

  gbServerPort: '',

  gbServerId: '',

  gbAgentId: '',

  gbPassword: '',

  gbAgentPort: '',

  gbAgentChannel: '',

  // RTSP

  rtspUserName: '',

  rtspPassword: '',

  rtspPort: '8554',

  // Agora

  agoraAPPID: '',

  agoraToken: '',

  agoraChannel: '',

  // map

  amapKey: '',

}
